import { render, staticRenderFns } from "./SuportePagina.vue?vue&type=template&id=85b6b43c&"
import script from "./SuportePagina.vue?vue&type=script&lang=js&"
export * from "./SuportePagina.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports